import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsUserAccountEnabled } from '../../store/userAccount/userAccount.selectors'
import { isGE } from '../Device'
import { AddressFavoriteButton } from '../UserAccount/connected/userFavorites/FavoriteButton'
import s from './AddressContent.less'
import AddressCoordinates from './AddressCoordinates'
import AddressDescription from './AddressDescription'
import AddressPanoPreview from './AddressPanoPreview'
import AddressShareButton from './AddressShareButton'

const AddressContent = ({ address }) => {
  const { split_label } = address
  const shouldDisplayFavoriteButton = useSelector(selectIsUserAccountEnabled)

  return (
    <>
      {isGE() && <AddressPanoPreview />}
      <div className={s.addressContent}>
        <div className={s.mainHeader}>
          <div className={s.addressInfo}>
            <h1 className={s.addressTitle}>
              <span className={s.locationMainAddress}>{split_label?.[0]}</span>
              <span className={s.locationSubAddress}>{split_label?.[1]}</span>
            </h1>
            <AddressCoordinates address={address} />
          </div>
          <div className={s.actions}>
            <div className={s.actionBtnWrapper}>
              <AddressShareButton />
            </div>
            {shouldDisplayFavoriteButton && (
              <div className={s.actionBtnWrapper}>
                <AddressFavoriteButton />
              </div>
            )}
          </div>
        </div>
        <AddressDescription />
      </div>
      {!isGE() && <AddressPanoPreview />}
    </>
  )
}

export default AddressContent
